import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from "react-router-dom";
import { Menu, Play } from "lucide-react";
import { Button } from "@/components/ui/Button";
const titles = {
    "/": "Dashboard",
    "/timesheet": "Weekly Timesheet",
    "/entries": "Entries",
    "/staff-entries": "Staff Entries",
    "/approvals": "Approvals",
    "/billing": "Client Billing",
    "/work-orders": "Work Orders",
    "/projects": "Projects",
};
export function TopBar({ onStartTimer, onMenuClick, }) {
    const { pathname } = useLocation();
    const title = titles[pathname] ?? "TimeTrack Pro";
    return (_jsxs("div", { className: "flex items-center justify-between gap-2 px-4 sm:px-6 lg:px-8 py-3 sm:py-4 border-b border-slate-200 bg-white/70 backdrop-blur", children: [_jsxs("div", { className: "flex items-center gap-2 min-w-0", children: [onMenuClick && (_jsx("button", { onClick: onMenuClick, className: "md:hidden rounded-md p-2 -ml-1 text-slate-600 hover:bg-slate-100", "aria-label": "Open menu", children: _jsx(Menu, { size: 18 }) })), _jsx("div", { className: "text-sm text-slate-500 truncate", children: title })] }), _jsxs(Button, { onClick: onStartTimer, leftIcon: _jsx(Play, { size: 14, fill: "currentColor" }), children: [_jsx("span", { className: "hidden sm:inline", children: "Start Timer" }), _jsx("span", { className: "sm:hidden", children: "Timer" })] })] }));
}
